import React from "react";
import { Menu, UtensilsCrossed } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function Navbar({
  isScrolled,
  activePage,
  onNavigate,
  onOpenMobileMenu,
  LanguageSelection,
}) {
  const solid = isScrolled || activePage !== "home";
  const { t } = useI18n();

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-in-out border-b will-change-transform ${
        solid
          ? "bg-white/95 backdrop-blur-md border-gray-100 py-3 shadow-sm"
          : "bg-gradient-to-b from-black/90 to-transparent border-transparent py-6"
      }`}
    >
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between">
        {/* Logo */}
        <div
          className="flex items-center gap-3 z-50 group cursor-pointer"
          onClick={() => onNavigate("home")}
        >
          <div
            className={`p-2 rounded-full border transition-colors duration-300 ${
              solid
                ? "border-[#c32228] text-[#c32228]"
                : "border-white/30 text-white bg-white/10"
            }`}
          >
            <UtensilsCrossed size={22} strokeWidth={1.5} />
          </div>

          <div className="flex flex-col">
            <span
              className={`text-2xl font-serif font-bold tracking-wide leading-none ${
                solid ? "text-[#8a1c20]" : "text-white"
              }`}
            >
              {t("nav.brandName")}<span className="text-[#c32228]">{t("nav.brandHighlight")}</span>
            </span>
            <span
              className={`text-[10px] tracking-[0.3em] uppercase opacity-90 ${
                solid ? "text-gray-500" : "text-gray-300"
              }`}
            >
              {t("nav.fineDining")}
            </span>
          </div>
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-10 absolute left-1/2 transform -translate-x-1/2">
          {[
            { name: t("nav.home"), id: "home" },
            { name: t("nav.categories"), id: "categories" },
            { name: t("nav.products"), id: "products" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={`text-sm font-bold tracking-widest uppercase relative group transition-colors duration-300 ${
                solid ? "text-gray-800 hover:text-[#c32228]" : "text-white hover:text-[#c32228]"
              } ${activePage === item.id ? "text-[#c32228]" : ""}`}
            >
              {item.name}
              <span
                className={`absolute -bottom-2 right-0 h-0.5 bg-[#c32228] transition-all duration-300 origin-right ${
                  activePage === item.id
                    ? "w-full"
                    : "w-0 group-hover:w-full"
                }`}
              />
            </button>
          ))}
        </div>

        {/* Right */}
        <div className="hidden md:flex items-center gap-6">
          <LanguageSelection isMobile={false} />
        </div>

        {/* Mobile Toggle */}
        <button
          onClick={onOpenMobileMenu}
          className={`md:hidden z-50 p-2 -mr-2 transition-colors cursor-pointer ${
            solid ? "text-[#8a1c20]" : "text-white"
          }`}
          aria-label="القائمة"
        >
          <Menu size={28} strokeWidth={1.5} />
        </button>
      </div>
    </nav>
  );
}
